<template>
  <dashboard-card class="db-guides" title="Situação das guias"
                  note="Clique na linha para abrir a lista filtrada">
    <div class="loading loading-lg db-card-loading" v-if="loading"></div>

    <dashboard-empty
      v-else-if="isEmpty"
      icon="check-circle"
      title="Nenhuma guia em aberto no período"
      reason="Nada para digitar, enviar ou recursar. Se esperava movimento aqui, troque a
              competência ou o convênio."
      :action-to="allGuidesRoute"
      action-label="Ver as guias da competência"
      action-icon="file-medical-alt"
    />

    <div class="db-card-table" v-else>
      <table class="table">
        <thead>
          <tr>
            <th>Situação</th>
            <th class="text-right">Qtd.</th>
            <th class="text-right">Ação</th>
          </tr>
        </thead>
        <tbody>
          <tr class="db-row" v-for="row in rows" :key="row.key"
              :class="{'is-zero': row.count === 0}" @click="open(row)">
            <td class="db-name">
              <i class="db-dot" :class="row.dotClass"></i>{{ row.label }}
              <span class="db-sub" v-if="row.value > 0">
                {{ row.value | currency }}{{ row.valueLabel }}
              </span>
            </td>
            <td class="text-right db-num db-count">{{ row.count }}</td>
            <td class="text-right">
              <span class="db-pill" :class="row.pillClass" v-if="row.count > 0">
                {{ row.action }}
              </span>
              <span class="db-muted" v-else>—</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </dashboard-card>
</template>

<script>
import {
  competenceRange, glossesRoute, guidesRoute, GUIDES_PATH,
} from '../helpers';
import DashboardCard from './DashboardCard.vue';
import DashboardEmpty from './DashboardEmpty.vue';

const ROWS = [
  {
    key: 'pending', situation: 'pending', label: 'Pendentes de digitação', action: 'urgente', tone: 'amber',
  },
  {
    key: 'glossed',
    situation: 'glossed',
    label: 'Negadas / glosadas',
    action: 'recurso',
    tone: 'red',
    valueLabel: ' glosados',
  },
  {
    key: 'expired', situation: 'expired', label: 'Vencidas', action: 'perda', tone: 'red',
  },
];

export default {
  components: {
    DashboardCard,
    DashboardEmpty,
  },
  props: {
    guides: {
      type: Object,
      required: true,
    },
    filter: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    rows() {
      return ROWS.map((row) => {
        const block = this.guides[row.key] || { count: 0, value: 0 };
        const zero = block.count === 0;
        return {
          ...row,
          count: block.count,
          value: block.value,
          valueLabel: row.valueLabel || '',
          dotClass: zero ? 'db-dot-gray' : `db-dot-${row.tone}`,
          pillClass: `db-pill-${row.tone}`,
          to: row.situation === 'glossed'
            ? glossesRoute(this.filter)
            : guidesRoute(row.situation, this.filter),
        };
      });
    },
    isEmpty() {
      return this.rows.every(row => row.count === 0);
    },
    allGuidesRoute() {
      return { path: GUIDES_PATH, query: competenceRange(this.filter.competence) };
    },
  },
  methods: {
    open(row) {
      if (row.count === 0) return;
      this.$router.push(row.to);
    },
  },
};
</script>
